import { gql } from '@apollo/client';

export const QUERY_SCALE_DASHBOARD_HISTORICAL_MAX = gql`
    query QueryScaleDashboardHistoricalMax($input: ScaleDashboardHistoricalMaxQueryInput!) {
        queryScaleDashboardHistoricalMax(input: $input) {
            queryType
            metric
            maxValue
            maxPeriods
            startDate
            endDate
        }
    }
`;

